/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30RequestBody } from './Oas30RequestBody';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas30RequestBody
 * @author eric.wittmann@gmail.com
 */
export class Oas30RequestBodyDefinition extends Oas30RequestBody implements IDefinition {
    /*private*/ _name : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IVisitable#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitRequestBodyDefinition(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }
}
Oas30RequestBodyDefinition["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition";
Oas30RequestBodyDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent","io.apicurio.datamodels.core.models.common.INamed"];




